import React from 'react'
import PropTypes from 'prop-types'

import CustomPropTypes from '../../customPropTypes'
import {defaultMetaDescription} from '../../seo'

import Page from './Page'

import hpOg from '../../../../img/hp/hp-og-1200x630.jpg'

const BasicPage = ({children, className, description, image, nonIndexable, title}) => (
  <Page
    className={className}
    meta={{
      description,
      image: {
        type: image.type,
        url: image.urlSecure,
      },
      og: {
        description,
        image: {
          height: image.height,
          type: image.type,
          url: image.urlSecure,
          urlSecure: image.urlSecure,
          width: image.width,
        },
        title,
      },
      title,
      twitter: {
        card: 'summary_large_image',
        description,
        image: image.urlSecure,
        title,
      },
      nonIndexable,
    }}
  >
    {children}
  </Page>
)

BasicPage.defaultProps = {
  description: defaultMetaDescription,
  image: {
    height: 630,
    type: 'image/jpeg',
    urlSecure: hpOg,
    width: 1200,
  },
}

BasicPage.propTypes = {
  children: CustomPropTypes.children,
  className: PropTypes.string,
  description: PropTypes.string.isRequired,
  image: PropTypes.shape({
    height: PropTypes.number.isRequired,
    type: PropTypes.string.isRequired,
    urlSecure: PropTypes.string.isRequired,
    width: PropTypes.number.isRequired,
  }).isRequired,
  title: PropTypes.string.isRequired,
  nonIndexable: PropTypes.bool,
}

export default BasicPage
